module.exports = __webpack_public_path__ + "images/icon_gamble_horizontal_c69c109ee9a6911624b6b652af57168b.svg";